export enum CompanyType {
    Customer = 'customer',
    Manufacturer = 'manufacturer',
}
